import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './app.home.component';
import { JobsComponent } from './Jobs/jobs.component';
import { FeatureTestingComponent } from './feature-testing/feature-testing.component';
import { MaintenanceTaskSchedulerComponent } from './maintenance-task-scheduler/maintenance-task-scheduler.component';
import { LocalisationComponent } from './Localisation/localisation.component';
import { FeatureManagementComponent } from '@app/FeatureManagement/featureManagement.component';
import { NewTenantComponent } from './Tenant/Components/NewTenant/new-tenant.component';
import { NewTenantTrialComponent } from './Tenant/Components';
import { TrialGuard } from './Tenant/guards/free-trial.guard';
import { ENVIRONMENT_ROUTES } from '@app/Environments/environments.routes';
import { TENANT_ROUTES } from './Tenant/tenant.routes';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'jobs/:id',
        component: JobsComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'jobs',
        component: JobsComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'feature-testing',
        component: FeatureTestingComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'maintenancetaskscheduler',
        component: MaintenanceTaskSchedulerComponent,
        canActivate: [MsalGuard]
    },
    ...ENVIRONMENT_ROUTES,
    {
        path: 'localisation',
        component: LocalisationComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'feature/management',
        component: FeatureManagementComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'newtenant',
        component: NewTenantComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'new-trial',
        component: NewTenantTrialComponent,
        canActivate: [MsalGuard, TrialGuard]
    },
    ...TENANT_ROUTES
];
